module.exports = __webpack_public_path__ + "img/23.problem_door.de43bbeb.svg";